const headerDatatow = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "StatusName",
		label: "状态",
		columnwidth: 100,
	},
	{
		prop: "VouCode",
		label: "经销商入库单号",
		columnwidth: 230,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 180,
	},
	{
		prop: "VoucherType",
		label: "单据类型",
		columnwidth: 220,
	},
	{
		prop: "Organization",
		label: "一级经销商编号",
		columnwidth: 180,
	},
	{
		prop: "CompanyName",
		label: "一级经销商名称",
		columnwidth: 180,
	},
	{
		prop: "CusCode",
		label: "经销商编号",
		columnwidth: 100,
	},
	{
		prop: "CusName",
		label: "经销商名称",
		columnwidth: 250,
	},
	{
		prop: "ExpressCode",
		label: "运单号",
		columnwidth: 180,
	},
	{
		prop: "ExpressCode",
		label: "运单号",
		columnwidth: 180,
	},
	{
		prop: "WHCode",
		label: "仓库编号",
		columnwidth: 100,
	},
	{
		prop: "WHName",
		label: "仓库名称",
		columnwidth: 180,
	},
	{
		prop: "OWhName",
		label: "调出公司",
		columnwidth: 180,
	},
	{
		prop: "Remark",
		label: "备注",
		columnwidth: 180,
	},
	{
		prop: "OrgCode",
		label: "经销商订单号",
		columnwidth: 180,
	},
	{
		prop: "OuterCode",
		label: "外部单据号",
		columnwidth: 180,
	},
	{
		prop: "Total",
		label: "总金额",
		columnwidth: 180,
	},
	{
		prop: "DamageCode",
		label: "报损出库单号",
		columnwidth: 150, 
	},
	{
		prop: "BuyerName",
		label: "报损付款方",
		columnwidth: 200,
	},
	{
		prop: "TerminalHPName",
		label: "报损终端医院",
		columnwidth: 200,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 180,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 180,
	},
	{
		prop: "UpdaterName",
		label: "修改人",
		columnwidth: 180,
	},
	{
		prop: "UpdateTime",
		label: "修改时间",
		columnwidth: 180,
	},
	{
		prop: "VerifierName",
		label: "审核人",
		columnwidth: 180,
	},
	{
		prop: "VerifyTime",
		label: "审核时间",
		columnwidth: 180,
	},
]
export default headerDatatow